import { render, staticRenderFns } from "./MemberCompetition.vue?vue&type=template&id=82066854&scoped=true&"
import script from "./MemberCompetition.vue?vue&type=script&lang=js&"
export * from "./MemberCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82066854",
  null
  
)

export default component.exports